export const SPLIT_SCREEN = {
  SHOW_SPLIT_SCREEN: 'showSplitScreen',
  DONT_SHOW_SPLIT_SCREEN: 'dontShowSplitScreen',
  ARRAY_VALUES: ['showSplitScreen', 'dontShowSplitScreen'],
};
